import * as React from "react";
import { DocumentItem } from "../../model/autogen/DocumentItem";
import { RenderDocumentItemDisplay } from "./common";
import { DebateNotesModel } from "../../model/autogen/DebateNotesModel";
import { DebateNoteSubType, DebateNoteSubType_DISPLAY_NAMES } from "../../model/autogen/DebateNoteSubType";
import { getBillStages, getPartyPositions } from "../../model/enum-display";
import { PeopleItemRoute } from "../../route-paths";
import { Link } from "react-router-dom";
import { SanitisedHtml } from "../html";
import { FileAttachmentList, IFileAttachmentCallbacks } from "../file-attachment-list";
import { LinkCollectionDisplay } from "../link-collection-display";
import { downloadLinkResolver } from "../../pages/brief-item-page";

export function getDisplayLabels(subType: DebateNoteSubType) {
    let ministerLabel = "Minister";
    if (subType == DebateNoteSubType.MembersBill) {
        ministerLabel = "Bill Sponsor";
    } else if (subType != DebateNoteSubType.GovernmentBill) {
        ministerLabel = "Responsible MP";
    }
    let summaryLabel = "Summary";
    let bodyLabel = "Body";
    let billStageLabel = "Stage of Bill";
    let partyPositionLabel = "Labour's Position";
    let speechesLabel = "Documents";
    let existingSpeechesLabel = "Existing Documents";
    let linksLabel = "Media Articles and Links";
    return {
        ministerLabel,
        summaryLabel,
        bodyLabel,
        billStageLabel,
        partyPositionLabel,
        speechesLabel,
        existingSpeechesLabel,
        linksLabel
    }
}

export function renderDebateContents(sortedItems: DocumentItem[], model: DebateNotesModel, callbacks: IFileAttachmentCallbacks) {
    const {
        ministerLabel,
        summaryLabel,
        billStageLabel,
        bodyLabel,
        speechesLabel,
        partyPositionLabel,
        linksLabel
    } = getDisplayLabels(model.subType);
    
    const bill = getBillStages().filter(a => a[0] == model.billStage)[0];
    const position = getPartyPositions().filter(a => a[0] == model.partyPosition)[0];
    return <>
        <article>
            <h3>Type</h3>
            <p>{DebateNoteSubType_DISPLAY_NAMES[model.subType]}</p>
        </article>
        {model.minister != null && <article>
            <h3>{ministerLabel}</h3>
            <p><Link to={PeopleItemRoute()(model.minister.id)}>{model.minister.name}</Link></p>
        </article>}
        <article>
            <h3>{summaryLabel}</h3>
            <SanitisedHtml html={model.summary} />
        </article>
        {(model.subType == DebateNoteSubType.GovernmentBill || model.subType == DebateNoteSubType.MembersBill) && <article>
            <h3>{billStageLabel}</h3>
            <p>{(bill && bill[1]) || "<unspecified>"}</p>
        </article>}
        {model.subType == DebateNoteSubType.MembersBill && <article>
            <h3>{partyPositionLabel}</h3>
            <p>{(position && position[1]) || "<unspecified>"}</p>
        </article>}
        <article>
            <h3>{bodyLabel}</h3>
            {model.items.map(RenderDocumentItemDisplay)}
        </article>
        {(model.subType == DebateNoteSubType.GovernmentBill || model.subType == DebateNoteSubType.MembersBill) && <article>
            <h3>{speechesLabel}</h3>
            <FileAttachmentList files={model.files} downloadLinkResolver={downloadLinkResolver} editing={false} {...callbacks} />
        </article>}
        <article>
            <h3>{linksLabel}</h3>
            <LinkCollectionDisplay links={model.links} />
        </article>
    </>
}


// WEBPACK FOOTER //
// ./src/components/display/debate-notes-display.tsx